import React, { createContext, useEffect, useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import SessionManager from "../Utils/Session";

export const AuthContext = createContext();

export const AuthContextProvider = ({ children }) => {
  const [user, setUser] = useState({});
  const [coordinator, setCoordinator] = useState({});
  const [isAuthenticated, setIsAuthenticated] = useState(typeof SessionManager.shared.getSessionToken !== "undefined" && SessionManager.shared.getSessionToken && SessionManager.shared.getSessionToken !== "");
  const [isCoordinatorAuthenticated, setIsCoordinatorAuthenticated] = useState(
    typeof SessionManager.shared.getCoordinatorToken !== "undefined" &&
    SessionManager.shared.getCoordinatorToken &&
    SessionManager.shared.getCoordinatorToken !== ""
  );
  // Effect to synchronize AuthContext with SessionManager on mount
  useEffect(() => {
    const sessionToken = SessionManager.shared.getSessionToken();
    const coordinatorToken = SessionManager.shared.getCoordinatorToken();
    const userData = SessionManager.shared.retrieveUserData();
    const coordinatorData = SessionManager.shared.retrieveCoordinatorData();

    if (typeof sessionToken !== "undefined" && sessionToken && sessionToken != "") {
      setIsAuthenticated(true);
      SessionManager.shared.getData();
    } else {
      setIsAuthenticated(false);
    }
    if (typeof coordinatorToken !== "undefined" && coordinatorToken && coordinatorToken !== "") {
      setIsCoordinatorAuthenticated(true);
      SessionManager.shared.getCoordinatorData();
    } else {
      setIsCoordinatorAuthenticated(false);
    }

    if (sessionToken && userData) {
      setUser(userData);
    } else {
      setUser({
        name: "Admin"
      })
    }
    if (coordinatorToken && coordinatorData) {
      setCoordinator(coordinatorData);
    } else {
      setCoordinator({
        name: "Coordinator"
      });
    }
  }, []); // Only run on component mount

  // Listen for changes in SessionManager and update AuthContext accordingly
  useEffect(() => {
    const handleTokenChange = () => {
      const sessionToken = SessionManager.shared.getSessionToken();
      const coordinatorToken = SessionManager.shared.getCoordinatorToken();

      if (typeof sessionToken !== "undefined" && sessionToken && sessionToken != "") {
        setIsAuthenticated(true);
        SessionManager.shared.getData();
      } else {
        setIsAuthenticated(false);
      }
      if (typeof coordinatorToken !== "undefined" && coordinatorToken && coordinatorToken !== "") {
        setIsCoordinatorAuthenticated(true);
        SessionManager.shared.getCoordinatorData();
      } else {
        setIsCoordinatorAuthenticated(false);
      }
    };

    const handleDataChange = () => {
      const sessionToken = SessionManager.shared.getSessionToken();
      const coordinatorToken = SessionManager.shared.getCoordinatorToken();
      const userData = SessionManager.shared.retrieveUserData();
      const coordinatorData = SessionManager.shared.retrieveCoordinatorData();

      if (sessionToken && userData) {
        setUser(userData);
      } else {
        setUser({
          name: "Admin"
        })
      }
      if (coordinatorToken && coordinatorData) {
        setCoordinator(coordinatorData);
      } else {
        setCoordinator({
          name: "Coordinator"
        });
      }
    };

    // Subscribe to SessionManager changes
    SessionManager.shared.subscribeData(handleDataChange);
    SessionManager.shared.subscribeToken(handleTokenChange);

    // Clean up subscription on unmount
    return () => {
      SessionManager.shared.unsubscribeData(handleDataChange);
      SessionManager.shared.unsubscribeToken(handleTokenChange);
    };
  }, []); // Only run on component mount and unmount

  const updateUserCartCount = (newCartCount) => {
    setUser((prevUser) => ({
      ...prevUser,
      cartCount: newCartCount
    }));
  };
  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        setIsAuthenticated,
        user,
        setUser,
        updateUserCartCount, // Provide the method to update cart count
        isCoordinatorAuthenticated,
        coordinator,
        setCoordinator,
      }}>
      {children}
    </AuthContext.Provider>
  );
};
